import { IMotoristaRepository } from '../repositories/IMotoristaRepository'

export interface IDeleteMotorista {
  execute(id: number, frotistaId: number): Promise<void>
}

export default class DeleteMotoristaImpl implements IDeleteMotorista {
  constructor(private readonly motoristaRepository: IMotoristaRepository) {}
  async execute(id: number, frotistaId: number): Promise<void> {
    await this.motoristaRepository.delete(id, frotistaId)
  }
}
